module.exports = __webpack_public_path__ + "img/united-kingdom.e5564902.svg";